export default __webpack_public_path__ + "static/media/Dinheiro.e2a18d64.svg";